import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=11541d85&scoped=true"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=11541d85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11541d85",
  null
  
)

export default component.exports